import React from 'react';
import { Button, Input, Label, Card, CardHeader, CardTitle, CardContent, CardDescription } from '@clinic-os/ui';
import type { ClinicType } from '@clinic-os/shared/types';

export function SettingsPage() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-semibold text-slate-900 mb-6">Settings</h1>

      <div className="space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>Clinic Information</CardTitle>
            <CardDescription>Basic clinic details shown to patients</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <Label htmlFor="name">Clinic Name</Label>
                <Input id="name" defaultValue="Smile Dental Clinic" />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="type">Clinic Type</Label>
                <Input id="type" defaultValue="dental" disabled />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="address">Address</Label>
              <Input id="address" defaultValue="123 Sukhumvit Road, Bangkok" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <Label htmlFor="phone">Phone</Label>
                <Input id="phone" defaultValue="+66 2 123 4567" />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" defaultValue="contact@smiledental.co.th" />
              </div>
            </div>
            <div className="pt-2">
              <Button size="lg">Save Changes</Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Working Hours</CardTitle>
            <CardDescription>Set your clinic's operating hours</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day) => (
              <div key={day} className="flex items-center gap-4">
                <span className="w-24 text-sm text-slate-600">{day}</span>
                <Input type="time" defaultValue="09:00" className="w-32" aria-label={`${day} opening time`} />
                <span className="text-slate-500">to</span>
                <Input type="time" defaultValue="18:00" className="w-32" aria-label={`${day} closing time`} />
              </div>
            ))}
            <div className="pt-2">
              <Button size="lg">Save Hours</Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Billing</CardTitle>
            <CardDescription>Invoice numbering and tax settings</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <Label htmlFor="taxId">Tax ID</Label>
                <Input id="taxId" defaultValue="0105541234567" />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="taxRate">Tax Rate (%)</Label>
                <Input id="taxRate" type="number" defaultValue="7" />
              </div>
            </div>
            <div className="pt-2">
              <Button size="lg">Save Billing Settings</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
